import { useEffect, useRef, useState } from 'react';

enum LoadingState {
    PENDING = 0,
    LOADING = 1,
    COMPLETED = 2
}

export function useLoadingDelay(isLoading: boolean, minimumDelay: number = 1000): boolean {
    const [status, setStatus] = useState<LoadingState>(LoadingState.PENDING);
    const startedAt = useRef(Date.now());

    useEffect(() => {
        if (status !== LoadingState.LOADING && isLoading) {
            setStatus(LoadingState.LOADING);
            startedAt.current = Date.now();
        }

        if (status === LoadingState.LOADING && !isLoading) {
            const elapsed = Date.now() - startedAt.current;
            const delay = Math.max(0, minimumDelay - elapsed);
            setTimeout(() => setStatus(LoadingState.COMPLETED), delay);
        }
    }, [isLoading, minimumDelay, status]);

    return status < LoadingState.COMPLETED;
}
